import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useTransferGroupOwner, useSetGroupAdmin } from "@/components/chat/GroupOperation";
import { SessionSettingsType, TransferGroupAdminSource } from "@/types/chat/enum";
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import IconFont from "@/components/icon";
import ScrollView from "@/baseComponents/ScrollView";
import noticeImg from "@/assets/img/empty/im-empty.png";
import { Drawer, message, Switch, Empty, Input } from "antd";
import isNull from "lodash/isNull";
import { Employee, GroupAttribute, Session, SessionProps, GroupRoster } from "@/types/chat";
import { sessionSetting } from "@/server/im/SessionService";
import GroupRobotOperate from "@/components/chat/SessionSetting/GroupBotsManager/robotOperate";
import Context from "@/components/chat/context";
import { groupGetBotList } from "@/api/egroup";
// sxl 连续点击switch 节流
import { debounce, throttle } from "lodash";
import bus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState, { ChatConnectState } from "@/types/chat/State";
import { useHistory } from "react-router-dom";
import "./index.less";
import GroupMemberOperate from "@/components/chat/GroupMembersV2/MemberOperateV2";
import { getGroupMemberList } from "@/api/chat";

interface Props {
    selectedSession: Session;
    sessionMembers: Partial<Employee>[];
    groupRobots: Partial<any>[];
    loadSessionMembers: Function;
    openAddRobotModal: Function;
}

type IProps = Readonly<Props>;

function GroupBotsManager(
    props: IProps & {
        visible: boolean;
        onClose: () => void;
        updateSessionData: Function;
        updateSelectedSession: Function;
        searchFunction: Function;
        searchPart: ReactNode;
        sessionMembers: [];
    }
) {
    const {
        visible,
        onClose,
        selectedSession,
        groupRobots,
        loadSessionMembers,
        updateSessionData,
        updateSelectedSession,
        openAddRobotModal,
        searchPart,
        searchFunction,
        sessionMembers
    } = props;

    const {
        currentEmployee,
        userData,
        groupRosterIdentity,
        aiMergeOptions
    } = React.useContext(Context);
    const { t } = useTranslation("chat");
    const [robotList, setRobotList] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [loading, setLoading] = useState(false);
    const [groupRosters, setGroupRosters] = useState<GroupRoster[]>([]);
    const currId = React.useRef("");

    const history = useHistory();

    const getRobotsList = useCallback(() => {
        groupGetBotList({ groupId: selectedSession.gid || "" }).then((res: any) => {
            console.log("res:", res);
            if (res.items) {
                setRobotList(res.items);
            }
        });
    }, [selectedSession]);


    const addRobot = () => {
        console.log("selectedSession:", selectedSession);
        openAddRobotModal({
            visible: true,
            addRobotModalGroupId: selectedSession.sessionId || selectedSession.gid || ""
        });
    };
    const titleNode = useMemo(() => {
        return (
            <div className="group-memberlist-right-drawer-head">
                <div className="title-icon">
                    <div className="icon">
                        <IconFont
                            className="app-region-none"
                            type="iconFrame-2"
                            onClick={onClose}
                        />
                    </div>
                    <div className="management-title">群成员</div>
                    <div className="icon close">
                        <IconFont
                            className="app-region-none"
                            type="iconguanbi"
                            onClick={onClose}
                        />
                    </div>
                </div>
                {searchPart}
            </div>

        );
    }, [onClose, t]);

    const getItemClasses = useCallback((item: any) => {
        return classNames({
            independent: true,
            pad: !item.info
        });
    }, []);

    const getAllGroupMembers = React.useCallback(
        (gid: string) => {
            if (!gid) {
                return;
            }
            if (!groupRosters?.length) {
                setLoading(true);
            }
            getGroupMemberList(gid, "group", selectedSession)
                .then(({ data, groupId }) => {
                    if (groupId === currId.current) {
                        setGroupRosters(data);
                        setLoading(false);
                    }
                })
                .catch((e) => {
                    console.log("getGroupMemberList--err", e);
                });
        },
        [selectedSession, groupRosters?.length]
    );

    return (
        <Drawer
            className="group-memberlist-right-drawer"
            getContainer={document.querySelector("#chat-right-container-change-set") as HTMLElement}
            title={titleNode}
            placement="right"
            width="340px"
            height="100%"
            headerStyle={{ borderBottom: "none", padding: "16px", backgroundColor: "#FAFAFA" }}
            bodyStyle={{ padding: "0px 16px 16px 16px", backgroundColor: "#FAFAFA" }}
            mask={false}
            destroyOnClose={true}
            closable={false}
            onClose={onClose}
            visible={visible}
            style={{ position: "absolute", right: 0 }}
        >
            {sessionMembers.length > 0 && (
                <ScrollView className="members_con_v2 scroll-view" nohorizontal="true">
                    {sessionMembers?.map((item: any, index: any) => {
                        return (
                            <div className={getItemClasses(item)} key={index}>
                                {item?.info && (
                                    <GroupMemberOperate
                                        member={item}
                                        getAllGroupMembers={getAllGroupMembers}
                                        keyword={keyword}
                                        canAddMember={true}
                                    />
                                )}
                            </div>
                        );
                    })}
                </ScrollView>
            )}
            {sessionMembers.length === 0 && (
                <Empty
                    className="botlist-nodata"
                    image={noticeImg}
                    imageStyle={{
                        height: 100
                    }}
                    description="暂无数据"
                />
            )}
        </Drawer>
    );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
    return {
        groupRosters: chat.groupRosters,
        groupRobots: chat.groupRobots,
        selectedSession: chat.selectedSession
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        async loadSessionMembers(data: { selectedSession: SessionProps }) {
            await dispatch({ type: "chat/loadSessionMembers", payload: data });
        },
        updateSessionData(data: { session: Session }) {
            dispatch({ type: "chat/updateSessionData", payload: data });
        },
        updateSelectedSession(data: { selectedSession: Session }) {
            dispatch({ type: "chat/updateSelectedSession", payload: data });
        },
        openAddRobotModal(data: any) {
            dispatch({ type: "ebook/openAddRobotModal", payload: data });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupBotsManager);
